import React, { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { AutoForm } from '../../../playground/common/auto-form';
import { UNIVERSITY_SAVINGS_V2_FIELDS } from './fields';
import { UniversitySavingsV2ResultView } from './result-view';
import {
  UniversitySavingsV2FormValues,
  universitySavingsV2Defaults,
  universitySavingsV2Schema,
} from './schema';
import { buildUniversitySavingsV2Payload, simulateUniversitySavingsV2 } from './service';

export function UniversitySavingsV2Page() {
  const [lastRequest, setLastRequest] = useState<unknown>(null);

  const mutation = useMutation({
    mutationFn: (values: UniversitySavingsV2FormValues) => simulateUniversitySavingsV2(values),
  });

  const hasResult = mutation.isSuccess || mutation.isError;

  return (
    <>
      <div className="card">
        <div className="card-body">
          <AutoForm
            fields={UNIVERSITY_SAVINGS_V2_FIELDS}
            schema={universitySavingsV2Schema}
            defaults={universitySavingsV2Defaults}
            isLoading={mutation.isLoading}
            onSubmit={(values) => {
              setLastRequest(buildUniversitySavingsV2Payload(values));
              mutation.mutate(values);
            }}
          />
        </div>
      </div>

      {hasResult && (
        <UniversitySavingsV2ResultView
          request={lastRequest}
          response={mutation.data}
          error={mutation.isError ? mutation.error : undefined}
        />
      )}
    </>
  );
}
